import { Plane } from "lucide-react";
import { useTranslation } from "react-i18next";

interface PlaneLoaderProps {
  message?: string;
  fullScreen?: boolean;
}

export const PlaneLoader = ({ message, fullScreen = true }: PlaneLoaderProps) => {
  const { t } = useTranslation();
  const loadingMessage = message || t("common.preparing_route", "מכין את המסלול...");

  const content = (
    <div className="flex flex-col items-center justify-center gap-4">
      {/* Animated Plane */}
      <div className="relative">
        {/* Glow effect */}
        <div className="absolute inset-0 animate-ping">
          <div className="h-16 w-16 rounded-full bg-primary/20" />
        </div>
        
        {/* Plane with bounce animation */}
        <div className="relative z-10 animate-bounce-gentle">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 backdrop-blur-sm">
            <Plane className="h-8 w-8 text-primary -rotate-45" />
          </div>
        </div>
        
        {/* Trail dots */}
        <div className="absolute -left-8 top-1/2 flex -translate-y-1/2 gap-1">
          <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary/40" style={{ animationDelay: "0ms" }} />
          <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary/30" style={{ animationDelay: "150ms" }} />
          <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary/20" style={{ animationDelay: "300ms" }} />
        </div>
      </div>
      
      {/* Loading text */}
      <p className="text-sm font-medium text-muted-foreground animate-pulse">
        {loadingMessage}
      </p>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/95 backdrop-blur-sm">
        {content}
      </div>
    );
  }

  return (
    <div className="flex min-h-[200px] items-center justify-center">
      {content}
    </div>
  );
};
